import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import './VerifyEmail.scss';

export class VerifyEmail extends Component {
	constructor(props) {
		super(props);
		this.state = {
			errorState: false
		};
	}

	backTo = () => {
		// Force a fresh Auth0 prompt so users can choose a different account.
		this.props.history.push("/login?prompt=login");
	};

	render() {
		return (

			<div className="VerifyContainer">

				<div>
					<div className="info">Almost there, your account is being verified. You'll be notified within 1 business day.
					</div>
					<div><b>Questions?</b> Contact <a href={`mailto:support@metabolon.com?subject=Email Verification`}>support</a> or <a data-testid="verifyemail-back" onClick={this.backTo}>return to login</a>.</div>
				</div>

			</div>
		);
	}
}

export default withRouter(VerifyEmail);